import r2wc from '@r2wc/react-to-web-component';
import { WebComponentWrapper } from './WebComponentWrapper.tsx';
import { StateViewPage } from '../components/Pages/StateViewPage.tsx';

const WrappedPage = ({ year }: { year?: number }) => {
	return (
		<WebComponentWrapper year={year} dataFormProvider>
			<StateViewPage />
		</WebComponentWrapper>
	);
};

export const WebStatePagePage = r2wc(WrappedPage, {
	props: { year: 'number' }
});
